import SoftButton from "components/SoftButton";
import React, { useState } from "react";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import { useAppServices, useUploadImage } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { EventNote, Note } from "@mui/icons-material";
import Editor from "../editor";
import { useLocation, useParams } from "react-router-dom";
import SoftInput from "components/SoftInput";

const PlanModal = ({ handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const params = useParams();
  const handlemodal = (event) => {
    event.stopPropagation();
    setOpenAddProduct(true);
  };
  const style = {
    width: 450,
  };
  function AddProduct({ open, onClose }) {
    const [agency] = useAgencyInfo();
    const { state } = useLocation();
    const [processing, setProcessing] = useState(false);
    const [message, setmessage] = useState("");
    const AppService = useAppServices();
    const handleSubmit = async (e) => {
      setProcessing(true);
      e.preventDefault();
      const payload = {
        name: e.target.name.value,
        color: e.target.color.value,
        // health_plan: e.target.health_plan.value,
        score: e.target.score.value,
        allowed_hours: e.target.allowed_hours.value,
        agency_id: agency._id,
      };

      const { response } = await AppService.health_plan.create({
        payload,
        toaster: true,
      });
      setProcessing(false);
      if (response) {
        onClose();
        handleRefresh();
      }
    };

    return (
      <SoftBox>
        <MDModal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <SoftBox role="form" component="form" onSubmit={handleSubmit} sx={style}>
            <SoftBox display="flex" alignItems="center" mb={2}>
              <SoftTypography variant="h6">Add New Plan</SoftTypography>
            </SoftBox>
            <SoftBox>
              <SoftTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "10px" }}
              >
                Name
              </SoftTypography>
              <SoftInput label="Plan Name" placeholder="Plan Name" name="name" fullWidth />
            </SoftBox>
            <SoftBox>
              <SoftTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "10px" }}
              >
                Color
              </SoftTypography>
              <SoftInput type="color" className="color-input" name="color" fullWidth />
            </SoftBox>
            <SoftBox>
              <SoftTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "10px" }}
              >
                Score
              </SoftTypography>
              <SoftInput
                type="number"
                label="Feature Score"
                placeholder="Feature Score"
                name="score"
                fullWidth
              />
            </SoftBox>
            <SoftBox>
              <SoftTypography
                variant="button"
                sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "10px" }}
              >
                Allowed Free Hours
              </SoftTypography>
              <SoftInput
                type="number"
                label="Feature Score"
                placeholder="Feature Score"
                name="allowed_hours"
                fullWidth
              />
            </SoftBox>
            <SoftBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              sx={{ mt: 4, mb: 1 }}
            >
              <SoftBox>
                <SoftButton
                  variant="outlined"
                  color="white"
                  sx={{
                    mr: 2,
                    "&:hover": {
                      background: "white",
                    },
                  }}
                  size="small"
                  onClick={onClose}
                >
                  Cancel
                </SoftButton>
                <SoftButton
                  variant="outlined"
                  color="dark"
                  type="submit"
                  loading={processing}
                  disabled={processing}
                  size="small"
                >
                  Add
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </MDModal>
      </SoftBox>
    );
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
      <SoftButton
        onClick={handlemodal}
        variant="contained"
        sx={{
          border: "1px solid hsl(205, 53%, 88%)",
          boxShadow: "none",
          Background: "transparent",
          fontSize: "12px",
          marginRight: "15px",
          color: "hsl(205, 47%, 42%)",
          fontWeight: "500",
          padding: "5px 12px",
          minHeight: "2.2rem",
          borderRadius: "8px",
          "&:hover": {
            boxShadow: "none",
            border: "1px solid #1554ED !important",
            background: "rgb(0, 102, 204) !important",
            color: "white !important",
            transform: "scale(1) !important",
          },
        }}
      >
        Add Plan
      </SoftButton>
    </>
  );
};

export default PlanModal;
PlanModal.propTypes = {
  open: PropTypes.bool,
  handleRefresh: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
